<template>
  <div>
    <Header v-if="!$route.meta.hideHeader && !$route.meta.HBFHeader" />
    <HeaderHBF v-if="$route.meta.HBFHeader" />
    <div class="flex-wrapper">
      <router-view :key="$route.fullPath" />
    </div>
    <!-- <Footer v-if="!($route.meta.hideHeader === true)" /> -->
    <FooterHBF />
  </div>
</template>

<script>
import Header from "@/components/layout/Header";
import HeaderHBF from "@/components/layout/HeaderHBF";
import Footer from "@/components/layout/Footer";
import FooterHBF from "@/components/layout/FooterHBF";

export default {
  name: "StandardLayout",
  components: {
    Header,
    HeaderHBF,
    Footer,
    FooterHBF
  },

  data() {
    return {
      isLoading: true,
      currentUrl: "",
      prevRoute: ""
    };
  },
  watch: {
    $route(pathUrl) {
      this.currentUrl = pathUrl.path;
      this.isLoading = true;
      /* setTimeout(() => {
        this.isLoading = false;
      }, 1500); */
    }
  },
  mounted() {
    this.currentUrl = window.location.pathname;
    /* -- what was this for?
    setTimeout(() => {
      this.isLoading = false;
    }, 2000);
     */
  }
};
</script>

<style>
.flex-wrapper {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  justify-content: space-between;
}
</style>
